import {mapGetters} from "vuex";

export const basePresenterMixin = {
		data() {
			return {
				ITEMS_PER_PAGE: 10,
				currentPage: 1,
				widgetReady: false,
				listView: true,
				mapCounter: 0,
				providerCoordinates: {}
			};
		},
		computed: {
			...mapGetters(['searchResults', 'paginatedResults', 'searching']),
			...mapGetters({showInOfficePlans: 'globalSettings/showInOfficePlans', showVirtualPlans: 'globalSettings/showVirtualPlans'}),
			searchResultsClass() {
				return this.showVirtualPlans ? 'col-lg-12' : 'col-lg-6';
			},
			searchResultClass() {
				return this.showVirtualPlans ? ['col-xs-12', 'col-sm-6', 'col-md-4', 'col-lg-4'] : [];
			},
			showPrevButton() {
				let show = this.currentPage > 1;
				return show;
			}
			,
			showNextButton() {
				let currentTotal = this.currentPage * this.ITEMS_PER_PAGE;
				let show = this.searchResults.length > currentTotal;
				return show;
			}
			,
			singleResultProviderEntityId() {
				if (!Array.isArray(this.searchResults) || this.searchResults.length !== 1) {
					return null;
				}
				const providerEntityId = this.searchResults[0].providerEntityId;
				return typeof providerEntityId === 'undefined' || providerEntityId === null
					? null
					: Number(providerEntityId);
			},
			resultsCountInfo() {
				return `${this.searchResults.length} result(s)`;
			},
			paginatorInfo() {
				let startOfPage = ((this.currentPage - 1) * this.ITEMS_PER_PAGE) + 1;
				let endOfPage = Math.min((startOfPage - 1 + this.ITEMS_PER_PAGE), this.searchResults.length);
				let info = `${startOfPage} - ${endOfPage} of ${this.searchResults.length} result(s)`;
				return info;
			},
			mapKey() {
				return `map-component-${this.mapCounter}`;
			},
			distance(){
				return this.searchResults.map(x => x.distance).sort(function (a, b) {return a > b ? 1 : -1;})[0];
			}
		},
		methods: {
			async baseInit() {
				//console.log("Before widget ready");
				this.widgetReady = false;
				await this.$store.dispatch("SET_CURRENT_PAGE", this.currentPage);
				this.addBusEvents();
				this.widgetReady = true;
			},
			switchToListView() {
				this.listView = true;
			},
			async loadPhysicians() {
				//console.log("Inside base search presenter, current page:", this.currentPage);
				await this.$store.dispatch("SET_CURRENT_PAGE", this.currentPage);
			},
			addBusEvents() {
				this.$bus.$on(this.$AcEvents.HIGHLIGHT_COORDINATES_IN_LIST, this.highlightSubscription);
				this.$bus.$on(this.$AcEvents.LOCATE_IN_MAP, this.locateInMap);
			},
			async locateInMap({latitude, longitude}) {
				this.mapData('providerCoordinates', {latitude, longitude})
				this.mapCounter++;
				this.listView = false;
			},
			highlightSubscription({latitude, longitude}) {
				let coordinateClass = 'coordinate-' + ((latitude + '' + longitude).replace(/\D/g, ''));
				$('.search-result').not('.' + coordinateClass).animate({opacity: 0.5}, 1000);
				$('.' + coordinateClass).animate({opacity: 1}, 500);
				let firstMatch = $('.' + coordinateClass).first();
				//console.log("First match:", firstMatch);
				$('html, body').animate({scrollTop: firstMatch.offset().top - 150}, 500);
			},
			loadPreviousPhysicians() {
				$(window).scrollTop(0);
				this.currentPage--;
				this.loadPhysicians();
			},
			loadNextPhysicians() {
				$(window).scrollTop(0);
				this.currentPage++;
				this.loadPhysicians();
			}
		}
	}
;